import type { ArticleTag, ArticleTagListProps } from '../../types';
import styles from './ArticleTagList.module.scss';

export interface ArticleTagListComponentProps extends ArticleTagListProps {
  onTagClick: (tag: ArticleTag) => void;
}

function ArticleTagList({ tags, onTagClick }: ArticleTagListComponentProps) {
  const handleClick = (e: React.MouseEvent, tag: ArticleTag) => {
    e.preventDefault();
    onTagClick(tag);
  };

  return (
    <ul className={styles.componentStyle}>
      {tags.map((tag, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: <explanation>
        <li key={index}>
          {/* biome-ignore lint/a11y/useValidAnchor: <explanation> */}
          <a
            className={styles.itemBlock}
            href='#'
            onClick={(e) => {
              handleClick(e, tag);
            }}
          >
            {tag.name}
          </a>
        </li>
      ))}
    </ul>
  );
}

export default ArticleTagList;
